export const GEOACCOUNT = 'geo.wps.cn'
export const ACCOUNT = 'account.wps.cn'
export const CONTRACT = 'contract.wps.cn'
export const DRIVE = 'drive.wps.cn'
export const DOCS = 'docs.wps.cn'
export const DOC2HTML = 'doc2html.wps.cn'
export const DWEBMODOU = 'dweb-modou.wps.cn'
export const DYNAMICEDU = 'dynamicedu.wps.cn'
export const DOCSERVER = 'docserver.wps.cn'
export const FORM = 'f.wps.cn'
export const FORMAPI = 'f-api.wps.cn'
export const FILEOPERATE = 'fileoperate.wps.cn'
export const FILECOLLECT = 'filecollect.wps.cn'
export const JUMP = 'jump.wps.cn'
export const KOA = 'koa.wps.cn'
export const KDOCSVCL = 'kdocs-vcl.ext.wps.cn'
export const MSGCENTER = 'msgcenter.wps.cn'
export const MSGEVENT = 'msgevent.wps.cn'
export const NOTE = 'note.wps.cn'
export const NOTEAPI = 'note-api.wps.cn'
export const OPEN = 'open.wps.cn'
export const OPENAPI = 'openapi.wps.cn'
export const PLUSSVR = 'plussvr.wps.cn'
export const PAYAPI = 'pay.wps.cn'
export const PAYCONFIGAPI = 'docs-dapi.wps.cn'
export const PLUS = 'plus.wps.cn'
export const PAN = 'pan.wps.cn'
export const WPSPAN = 'pan.wps.cn'
// export const QN = 'qn.cache.wpscdn.cn'
export const RILI = 'rili.wps.cn'
export const SECURITYDOC = 'securitydoc.wps.cn'
export const STORE = 'store.wps.cn'
export const TODO = 'todo.wps.cn'
export const TODOAPI = 'todos-api.wps.cn'
export const VIP = 'vip.wps.cn'
export const VIPCASHDESK = 'vip.wps.cn'
export const VIPERSOPNAL = 'personal-act.wps.cn'
export const VIPAPI = 'vipapi.wps.cn'
export const WORK = 'work.wps.cn'
export const WPS = 'www.wps.cn'
export const WEBOFFICE = 'web.wps.cn'
export const WOA = 'woa.wps.cn'
export const YUNBIZ = 'yunbiz.wps.cn'
// 个人团队相关
export const TWPS = 't.wps.cn'
// kdocs
export const EDUDOCS = 'edu.kdocs.cn'
export const EDUKDOCS = 'edu.kdocs.cn'
export const EDU = 'edu.kdocs.cn'
export const KDOCS = 'www.kdocs.cn'
export const KDOCSFIXED = 'www.kdocs.cn'
export const KDOCSCN = 'kdocs.cn'
export const DOCSK = 'docs.kdocs.cn'
export const MEETING = 'meeting.kdocs.cn'
export const PLUSSVRDOCS = 'plussvr.kdocs.cn'
export const TODOKDOCS = 'todos-api.kdocs.cn'
export const DCKDOCS = 'dc.kdocs.cn'
export const ACCOUNTKDOCS = 'account.kdocs.cn'

// others
export const AVATAR = 'vatar.qwps.cn'
export const DOCERKDOCS = 'docer.kdocs.cn'
export const DOCKERMOKDOCS = 'docer-mo.kdocs.cn' // 移动端
export const DOCERWPS = 'docer-kdocs.wps.cn'
export const DOCERMOWPS = 'kdocer-mo.wps.cn' // 移动端
export const DOCERHOME = 'www.docer.com'
export const IMG = 'img.qwps.cn'
export const IMAGE = 'image.qwps.cn'
export const IMAGEBUCKET = 'imagebucket.test.wpscdn.cn'
export const KDOCSOM = 'kdocs-om.wpscdn.cn'
export const DOCERVCLKDOCS = 'docer-vcl.kdocs.cn'
export const VIPAPIKDOCS = 'vipapi.kdocs.cn'
export const RESUMEWEB = 'resume-web.docer.wps.cn'
// 5g活动相关
export const HD = 'hd.wps.cn'
// 新分享相关
export const YUNAPI = 'yun-api.wps.cn'
// 发布场景相关
export const PUB = 'pub-api.wps.cn'
// 自建应用相关
export const DC = 'adc.wps.cn'
export const PUBLISH = 'pub-api.kdocs.cn'
export const PLUSKDOCS = 'plus.kdocs.cn'
// rili在某些情况下强制使用这个地址，不需要切换成rili.kdocs.cn
export const RILIWPS = 'rili.wps.cn'

export const PUBKDOCS = 'pub.kdocs.cn'
export const PUBWPS = 'publish.wps.cn'
export const PC = 'pc.kdocs.cn'
export const DOCERAPI = 'docer-api.kdocs.cn'
export const KDOC = 'wwww.kdoc.cn'
export const PORTAL = 'portal.wps.cn'
export const ECIS = 'ecis.wps.cn'
// 5G分享裂变活动
export const ZTKDOCS = 'zt.kdocs.cn'
export const TKDOCS = 't.kdocs.cn'
export const VAS = 'kvas-api.wps.cn'
export const VASKDOCS = 'vas-api.kdocs.cn'
export const PRIVACYWPS = 'privacy.wps.cn'
export const WXBMC = 'wxbmc.wps.cn'
export const WPS365 = '365.wps.cn'
export const WEBOFFICEPLUGIN = 'weboffice-plugin.wps.cn'
export const APKDOCS = 'p.kdocs.cn'
export const MOWEB = 'moweb.docer.wps.cn'
export const VAS2T = 'vas2t-api.wps.cn'
export const WPSPLUS = 'wpsplus.com'
// 面对面
export const FACE = 'face.kdocs.cn'
export const FACEWPS = 'face.wps.cn'
export const FACEAPI = 'face-api.kdocs.cn'
export const FACEAPIWPS = 'face-api.wps.cn'
// 天策
export const TIANCE = 'tiance.wps.cn'
export const VIPKDOCS = 'vip.kdocs.wps.cn'
// 服务中心
export const FEEDBACKWPS = 'get.wps.cn'
// V7域名
export const APIWPS = 'api.wps.cn'
// 联系人卡片
export const CONTACT = 'coop-contact.kdocs.cn'
export const CONTACTWPS = 'coop-contact.wps.cn'

// AI
export const COPILOT = 'copilot.wps.cn'